import React from 'react';
import AnalystCard from './AnalystCard';
import { Trophy } from 'lucide-react';

export default function AnalystLeaderboard({ analysts, loading, noLink = false, rankOffset = 0, onCardClick, showFollow = false, onAuthRequired, returnPeriod = 'all', periodField = {} }) {
  if (loading) {
    return (
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">
        {[...Array(8)].map((_, i) => (
          <div key={i} className="bg-white rounded-xl border border-gray-100 p-5 animate-pulse">
            <div className="flex items-start gap-3 mb-4">
              <div className="w-12 h-12 rounded-full bg-gray-200" />
              <div className="flex-1">
                <div className="h-4 bg-gray-200 rounded w-3/4 mb-2" />
                <div className="h-3 bg-gray-100 rounded w-1/2" />
              </div>
            </div>
            <div className="grid grid-cols-2 gap-2">
              {[...Array(2)].map((_, j) => (
                <div key={j} className="h-10 bg-gray-100 rounded" />
              ))}
            </div>
          </div>
        ))}
      </div>
    );
  }

  if (!analysts || analysts.length === 0) {
    return (
      <div className="text-center py-16 text-gray-400">
        <Trophy size={40} className="mx-auto mb-3 opacity-30" />
        <p className="font-medium">No analysts tracked yet.</p>
        <p className="text-sm mt-1">Add analysts via Django Admin to get started.</p>
      </div>
    );
  }

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">
      {analysts.map((analyst, idx) => (
        <div key={analyst.id} className="relative">
          <div className="absolute -top-2 -left-2 z-10 w-6 h-6 rounded-full bg-yellow-400 flex items-center justify-center text-xs font-black text-white shadow">
            {rankOffset + idx + 1}
          </div>
          <AnalystCard analyst={analyst} noLink={noLink} onCardClick={onCardClick} showFollow={showFollow} onAuthRequired={onAuthRequired} returnPeriod={returnPeriod} periodField={periodField} />
        </div>
      ))}
    </div>
  );
}
